module.exports = __webpack_public_path__ + "static/media/office_excel.9051cd5c.svg";